import { Dispatch, SetStateAction } from 'react';
import { useQuery } from 'react-query';

import {
  errorMessage,
} from '@features/applications';
import axiosInstance from '@server/axiosInstance';
import { hiredApplicantsRoute } from '../api/constant';
import { hiredApplicantsKey } from '../constants/constants';

type useGetHiredApplicantsProps = {
  setErrorText?: Dispatch<SetStateAction<string>>;
  enabled: boolean;
};

export const useGetHiredApplicants = ({
  setErrorText = () => {},
  enabled,
}: useGetHiredApplicantsProps) => {
  const { data: applicantsData, isFetching: isLoadingApplicantsData } =
    useQuery({
      queryKey: [hiredApplicantsKey],
      enabled: enabled,
      queryFn: () => {
        return axiosInstance.get(hiredApplicantsRoute).then((res) => res.data);
      },
      onSuccess: (data) => {
        if (data.object) {
          setErrorText('');
        }
        if (data.status !== 200) {
          setErrorText(data.message);
        }
      },
      onError: () => {
        setErrorText(errorMessage);
      },
      refetchOnWindowFocus: false,
    });

  return {
    applicantsData,
    isLoadingApplicantsData,
  };
};
